import React from "react";

import Tag from "antd/es/tag";

import { Deal } from "@mapmycustomers/shared/types/entity";
import { UserRef } from "@mapmycustomers/shared/types/User";
import { Avatar } from "@mapmycustomers/ui";

import DealName from "@app/component/deal/DealName";
import UserPreviewCard from "@app/component/UserPreviewCard";
import localSettings from "@app/config/LocalSettings";
import { formatRawDate } from "@app/util/formatters";

import styles from "../EntityListModal.module.scss";

import { ColumnsFactory } from "./ColumnsFactory";

export const createDealListColumns: ColumnsFactory<Deal> = (
  intl,
  { onCompanyPreview, onPersonPreview }
) => [
  {
    dataIndex: "name",
    render: (name, deal) => (
      <DealName deal={deal} onCompanyClick={onCompanyPreview} onPersonClick={onPersonPreview} />
    ),
    title: intl.formatMessage({
      id: "reports.overview.dealList.column.deal",
      defaultMessage: "Deal",
    }),
  },
  {
    className: styles.amount,
    dataIndex: "amount",
    render: (amount: number) =>
      intl.formatNumber(amount, {
        currency: localSettings.getCurrencyCode(),
        minimumFractionDigits: 0,
        style: "currency",
      }),
    title: intl.formatMessage({
      id: "reports.overview.dealList.column.amount",
      defaultMessage: "Amount",
    }),
  },
  {
    dataIndex: "closingDate",
    render: (closingDate: string) => <Tag>{formatRawDate(closingDate, "PPP")}</Tag>,
    title: intl.formatMessage({
      id: "reports.overview.dealList.column.closeDate",
      defaultMessage: "Close Date",
    }),
  },
  {
    dataIndex: "user",
    render: (user: UserRef) => (
      <UserPreviewCard userId={user.id}>
        <Avatar actionOnHover user={user} />
      </UserPreviewCard>
    ),
    title: intl.formatMessage({
      id: "reports.overview.dealList.column.owner",
      defaultMessage: "Owner",
    }),
    width: "15%",
  },
];
